'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

export default function HashScrollHandler() {
  const pathname = usePathname();

  useEffect(() => {
    // Only handle hash scrolling on the home page
    if (pathname !== '/') return;

    // Get hash from URL directly (avoid useSearchParams to prevent Suspense requirement)
    if (typeof window === 'undefined') return;
    
    const hash = window.location.hash;
    if (hash) {
      const sectionId = hash.replace('#', '');
      
      // Small delay to ensure page is rendered
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }, [pathname]);

  return null;
}

